export var NumberBadgeVariants;
(function (NumberBadgeVariants) {
    NumberBadgeVariants["neutral"] = "neutral";
    NumberBadgeVariants["primary"] = "primary";
    NumberBadgeVariants["secondary"] = "secondary";
    NumberBadgeVariants["error"] = "error";
})(NumberBadgeVariants || (NumberBadgeVariants = {}));
//# sourceMappingURL=constants.js.map